export const SeedOption : any = [
    {
        title : "Sql Seed",
        icon : "",
        description : ""
    },
    {
        title : "Laravel Seed",
        icon : "",
        description : ""
    },
    {
        title : "TypeOrm Seed",
        icon : "",
        description : ""
    }
]